export default __webpack_public_path__ + "static/4-56ede4d6ccc287a6866d4295c768eeb8.png";